import moment from 'moment';

export default function nextDay(now = moment()) {
  return moment(now).add(1, 'day').toISOString();
}
